import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-28 md:pt-36 pb-10 md:pb-16 px-4 text-center overflow-hidden" data-id="element-155">
      {/* Background image with low opacity */}
      <div className="absolute inset-0 z-0" data-id="element-156">
        <img src="https://cdn.magicpatterns.com/uploads/wAiKTLsJiQfJswLavWPCbj/ChatGPT_Image_27_mar_2026,_11_41_16_a.m..png" alt="" className="w-full h-full object-cover" data-id="element-157" />
        <div className="absolute inset-0 bg-white/80" data-id="element-158" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-159">
        <h1 className="text-3xl md:text-5xl font-black text-brand-dark mb-2 leading-tight tracking-tight" data-id="element-160">
          El ingeniero minero
          <br data-id="element-161" />
          que querés ser
          <br data-id="element-162" />
          <span className="text-brand-blue underline decoration-brand-orange decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8 uppercase" data-id="element-163">
            EMPIEZA HOY
          </span>
        </h1>

        {/* Payment Security Section */}

        <div className="mt-6 mb-4 flex justify-center" data-id="element-164">
          <img src="https://cdn.magicpatterns.com/uploads/iK78ShYQxMiZHa9tgsgCiX/ChatGPT_Image_27_mar_2026,_12_26_00_p.m..png" alt="MegaPack Especializaciones Mineras" className="w-72 h-72 md:w-[28rem] md:h-[28rem] object-contain drop-shadow-2xl rounded-xl" data-id="element-165" />
        </div>

        <p className="text-xl md:text-2xl italic text-gray-600 font-medium mb-5 md:mb-8" data-id="element-166">
          "52 CURSOS + SOFTWARES + MANUALES + SEGURIDAD"
        </p>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-10 leading-relaxed" data-id="element-167">
          El sistema que usan cientos de profesionales e ingenieros mineros en
          Argentina para especializarse, dominar los softwares más demandados
          del sector y acceder a capacitaciones de seguridad de nivel
          internacional — sin pagar cursos de miles de dólares, sin esperar
          meses y desde cualquier dispositivo.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-6 md:mb-8" data-id="element-168">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-169">
            📄 100% Digital
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-170">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-171">
            🇦🇷 Contenido en español
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-5" data-id="element-172">
          <CTAButton text="⛏️ → QUIERO MI MEGAPACK AHORA" href="#compra" isLink={true} data-id="element-173" />
        </div>

        <div className="max-w-xl mx-auto text-left text-xs md:text-sm text-gray-600 space-y-0.5 mb-5" data-id="element-174">
          <p data-id="element-175">🔒 Tu pago es 100% seguro</p>
          <p data-id="element-176">✅ No necesitás tener cuenta en Mercado Pago</p>
          <p data-id="element-177">✅ Podés pagar con tarjeta de débito o crédito</p>
          <p data-id="element-178">✅ También aceptamos transferencia bancaria o CVU</p>
          <p data-id="element-179">✅ Tus datos están protegidos en todo momento</p>
          <p data-id="element-180">📩 En menos de 5 minutos recibís todo en tu Google Drive</p>
          <p data-id="element-181">⚠️ Si no lo ves, revisá tu carpeta de Spam o Promociones</p>
        </div>

        <div className="flex justify-center mb-4" data-id="element-182">
          <img src="https://cdn.magicpatterns.com/uploads/5ZHwy7pq4xWzkYyw4KPizC/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="h-16 w-16 md:h-20 md:w-20" data-id="element-183" />
        </div>
      </div>
    </section>;
}